import { GetterTree } from 'vuex'
import RootState from '@/store/RootState'
import GlobalState from '@/store/modules/global/GlobalState'
import { Applications } from "@/types/application/applications"

export const getters: GetterTree<GlobalState, RootState> = {
  isDarkTheme (state) {
    return state.isDarkTheme
  },
  languageCode (state) {
    return state.languageCode
  },
  application (state) {
    if (!state.application) {
      return Applications.LINDENBERG
    }
    return state.application
  }
}
